<div class="container">
    <div class="col-md-12 d-flex align-items-center">
        <h4 class="font-weight-bold later-color title">Reporte individual</h4>
        <button
            class="btn btn-success ml-2 rounded-circle p-1 information-message"
            (click)="mostrarTexto()">
            <i class="fas fa-question"></i>
        </button>
    </div>
    <div class="form-group" style="max-width: 300px; margin-top: 1rem">
        <label for="tipoMoneda">Unidad de valor de moneda</label>
        <select
            [(ngModel)]="tipoMoneda"
            class="form-control"
            (change)="onCurrencyChange($event)">
            <option value="pesos">Pesos</option>
            <option value="miles">Miles de pesos</option>
            <option value="millones">Millones de pesos</option>
            <option value="milesMillones">Miles de millones</option>
        </select>
    </div>

    <div class="reporte-ventas_header">
        <label>Año a reportar {{ year }}</label>
        <label>Mes a reportar {{ month }}</label>
        <div class="reporte-ventas_conteiner-options">
            <input
                type="text"
                class="form-control"
                placeholder="Buscar..."
                [(ngModel)]="searchTerm"
                (input)="filterProducts()" />
            <button class="reporte_btn-accept" (click)="guardaInformacion()">
                Guardar
            </button>
            <button
                *ngIf="enviar"
                class="reporte_btn-accept"
                (click)="enviarReporte()">
                Enviar
            </button>
        </div>
    </div>

    <form>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th>Registro ICA</th>
                    <th>Tipo de producto</th>
                    <th>Nombre comercial producto</th>
                    <th>Unidad de presentación</th>
                    <th>Cantidad de Unidades Vendidas</th>
                    <th>Valor ventas totales</th>
                    <th>Valor Unitario</th>
                    <th>Cantidad de unidades en inventario</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let product of filteredProducts
                            ? filteredProducts
                            : products;
                        let i = index
                    ">
                    <td>{{ product.numeroRegistroIca }}</td>
                    <td>{{ product.tipoProducto }}</td>
                    <td>{{ product.nombreComercial }}</td>
                    <td>
                        {{ product.nombrePresentacion }} de
                        {{ product.cantidadPresentacion }}
                        {{ product.unidadPresentacion }}
                    </td>
                    <td>
                        <input
                            type="text"
                            min="0"
                            class="form-control"
                            [(ngModel)]="product.cantidadUnidadVendida"
                            name="product{{ product.id }}cantidadUnidadVendida"
                            (input)="
                                computoUnidadValorU(
                                    $event,
                                    'precioVenta',
                                    product
                                );
                                validarLimitesNumeros($event)
                            "
                            mask="separator.0" />
                    </td>
                    <td>
                        <div class="input-group">
                            <span class="input-group-text">
                                {{ currencySymbol }}
                            </span>
                            <input
                                type="text"
                                min="0"
                                class="form-control"
                                [(ngModel)]="product.precioVenta"
                                name="product{{ product.id }}precioVenta"
                                pattern="^\d+$"
                                (input)="
                                    computoUnidadValorU(
                                        $event,
                                        'precioVenta',
                                        product
                                    );
                                    validarLimitesNumeros($event, tipoMoneda)
                                "
                                mask="separator.1" />
                        </div>
                    </td>
                    <td>
                        <div class="input-group">
                            <input
                                type="text"
                                min="0"
                                class="form-control"
                                [(ngModel)]="product.valorUnitario"
                                name="product{{ product.id }}valorUnitario"
                                pattern="^\d+$"
                                readonly
                                mask="separator.1"
                                prefix="$" />
                        </div>
                    </td>
                    <td>
                        <input
                            type="text"
                            min="0"
                            class="form-control"
                            [(ngModel)]="product.volumenInventario"
                            name="product{{ product.id }}volumenInventario"
                            pattern="^\d+$"
                            (input)="validarLimitesNumeros($event)"
                            mask="separator.0" />
                    </td>
                </tr>
            </tbody>
        </table>
    </form>

    <!-- Mensaje de error general -->
    <div *ngIf="errors && errors.length > 0" class="alert alert-danger">
        <p>{{ errors[0].message }}</p>
    </div>

    <!-- Mensaje de éxito -->
    <div *ngIf="message" class="alert alert-success">
        {{ message }}
    </div>
</div>
